module.exports = __webpack_public_path__ + "c5be048b21ef85ff687fd92b59beb2c8.pdf";